import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { useState, useEffect } from 'react';
import { Product } from '../../models/Product';
import ProductFamilyTree, { ProductFamilyTreeSelectedItemInfo } from '../../components/editors/ProductFamilyTree';


function ProductFamilyTreeDropdown(props: {
    onProductSelected?: (item: Product) => void;
    onProductInfoSelected?: (item: ProductFamilyTreeSelectedItemInfo) => void;
    selectedProductInfo?: ProductFamilyTreeSelectedItemInfo;
}) {

    const [selectionInfo, setSelectionInfo] = useState<ProductFamilyTreeSelectedItemInfo>();    

    
    useEffect(() => {        

        if (selectionInfo != props.selectedProductInfo)
            setSelectionInfo(props.selectedProductInfo);

    }, [props.selectedProductInfo]);


    useEffect(() => {

        if (props.onProductSelected) {
            props.onProductSelected(selectionInfo ? selectionInfo.product : undefined);
        }

        if (props.onProductInfoSelected)
            props.onProductInfoSelected(selectionInfo);

    }, [selectionInfo]);


    return <UncontrolledDropdown>
        <DropdownToggle className="w-100 d-flex border" color="light">
            <span className="w-100 text-left">{selectionInfo && selectionInfo.fullName}
                {!(selectionInfo && selectionInfo.fullName) && 'Select Product Line'}
            </span>
            <i className="flex-shrink-1 align-self-center fa fa-angle-down"></i>
        </DropdownToggle>
        <DropdownMenu className="w-100 py-0">
            <div className="dropdown-menu-inner">
                <ProductFamilyTree onSelectedChanged={setSelectionInfo} />
            </div>
        </DropdownMenu>
    </UncontrolledDropdown>
}

export default connect()(ProductFamilyTreeDropdown);
